<script setup lang="ts">
import {
  ItinerarySegmentType,
  isItineraryLocationLoaderSegment,
  isItineraryDateLocationLoaderSegment,
  isItinerarySimpleTransportLoaderSegment,
  isItineraryBookableProductLoaderSegment,
} from '../../../models';
import { useTripOverviewPageStore } from '../../../stores';
import AddDestinationButton from '../AddDestinationButton.vue';
import ItinerarySimpleTransportSegment from '../ItinerarySimpleTransportSegment.vue';
import ItineraryNoTransportSegment from '../ItineraryNoTransportSegment.vue';
import ItineraryLocationSegment from '../location/ItineraryLocationSegment.vue';
import ItineraryDateLocationSegment from '../location/ItineraryDateLocationSegment.vue';
import ItineraryOwnStaySegment from '../ownStay/ItineraryOwnStaySegment.vue';
import ItineraryUpsellNoTransportSegment from '../ItineraryUpsellNoTransportSegment.vue';
import ItineraryStenaUpsellNoTransportSegment from '../ItineraryStenaUpsellNoTransportSegment.vue';
import { GlobalSuggestionTypeSwitch } from '../../globalSuggestionType';

import ItineraryProductLoaderSegment from './ItineraryProductLoaderSegment.vue';
import ItineraryUpsellingLoader from './ItineraryUpsellingLoader.vue';

const tripOverviewPageStore = useTripOverviewPageStore();
</script>

<template>
  <div class="trip-itinerary-loader">
    <div class="global-suggestion">
      <GlobalSuggestionTypeSwitch />
    </div>
    <div
      v-for="(segment, index) in tripOverviewPageStore.tripItineraryLoader"
      :key="index"
      :class="{
        'trip-itinerary-loader-segment': index === 0,
      }"
    >
      <ItineraryDateLocationSegment
        v-if="isItineraryDateLocationLoaderSegment(segment)"
        :segment="segment"
        :print-mode="false"
      />
      <ItineraryLocationSegment
        v-if="isItineraryLocationLoaderSegment(segment)"
        :segment="segment"
        :print-mode="false"
      />

      <ItineraryNoTransportSegment
        v-if="segment.segmentType === ItinerarySegmentType.NoTransport"
        :segment="segment"
        :print-mode="false"
        @select-transport="
          tripOverviewPageStore.selectTransport(segment, $event)
        "
      />

      <ItineraryUpsellingLoader
        v-if="segment.segmentType === ItinerarySegmentType.Upsell"
      />

      <ItineraryUpsellNoTransportSegment
        v-if="segment.segmentType === ItinerarySegmentType.UpsellNoTransport"
        :segment="segment"
      />

      <ItineraryStenaUpsellNoTransportSegment
        v-if="
          segment.segmentType === ItinerarySegmentType.StenaUpsellNoTransport
        "
        :segment="segment"
      />

      <ItinerarySimpleTransportSegment
        v-if="isItinerarySimpleTransportLoaderSegment(segment)"
        :segment="segment"
        is-loading-transport
        :print-mode="false"
        @select-transport="
          tripOverviewPageStore.selectTransport(segment, $event)
        "
      />

      <ItineraryOwnStaySegment
        v-if="segment.segmentType === ItinerarySegmentType.OwnStay"
        :segment="segment"
      />

      <ItineraryProductLoaderSegment
        v-if="isItineraryBookableProductLoaderSegment(segment)"
        :segment="segment"
      />
    </div>
    <AddDestinationButton />
  </div>
</template>

<style lang="scss" scoped>
.trip-itinerary-loader-segment {
  margin-top: var(--spacing-24);
}

.global-suggestion {
  box-shadow: 0px 3px 4px -1px rgba(32, 47, 71, 0.08);
  position: relative;
  @include for-more-or-equal-than-1200-px {
    position: sticky;
    top: 0;
    z-index: var(--modal-overlay-z-index);
  }
}
</style>
